import React, { useState } from "react";
import Modal1 from "../../DIsplay/Modal/Modal1";
import { useLocation, useNavigate } from "react-router-dom";
import { URLencode } from "../../../utils/url";
import { deleteVisaRequirementsApi } from "../../../controllers/visaController";
import { enqueueSnackbar } from "notistack";

function DeleteTransitVisaModal({ open, setOpen, data }) {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleDelete = async () => {
    setLoading?.(true);

    const res = await deleteVisaRequirementsApi(data?._id).finally(() =>
      setLoading?.(false)
    );

    if (res?.return) {
      enqueueSnackbar(
        res?.msg || "Transit visa requirement deleted successfully.",
        { variant: "success" }
      );

      setTimeout(() => {
        navigate(`${location.pathname}?${URLencode({ deleted: data?._id })}`);
      }, 300);
    } else {
      enqueueSnackbar(
        res?.msg ||
          "Failed to delete transit visa requirement. Please try again.",
        { variant: "error" }
      );
    }
  };

  return (
    <div>
      <Modal1 open={open} setOpen={setOpen}>
        <div className="p-6 flex flex-col items-center text-center">
          <h2 className="text-lg font-semibold text-gray-900 mb-2">
            Delete Transit Visa Requirement?
          </h2>

          <p className="text-sm text-gray-600 mb-6">
            Are you sure you want to delete this transit visa requirement? This
            action cannot be undone.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 w-full">
            {/* Cancel Button */}
            <button
              type="button"
              onClick={() => setOpen(false)}
              className="w-full sm:w-1/2 border border-gray-300 text-gray-700 rounded-md py-2.5 text-sm font-medium hover:bg-gray-50 transition"
            >
              No, Keep It
            </button>

            {/* Delete Button */}
            <button
              type="button"
              onClick={handleDelete}
              className="w-full sm:w-1/2 bg-red-600 text-white flex items-center justify-center rounded-md py-2.5 text-sm font-medium hover:bg-red-700 transition"
            >
              {loading ? (
                <div className="buttonLoader"></div>
              ) : (
                <>Yes, Delete</>
              )}
            </button>
          </div>
        </div>
      </Modal1>
    </div>
  );
}

export default DeleteTransitVisaModal;
